<app-tool-loader [isLoading]="isLoading()" positionUnset="true">

  <p-toolbar>
    <ng-template #start>
      <p-select [(ngModel)]="selectedRadiusType" (onChange)="onRadiusTypeChange($event)"
        optionValue="value" optionLabel="label" [options]="radiusTypes"></p-select>
    </ng-template>
  </p-toolbar>

  <app-ng-table-results 
    tableName="APB Results Grid" 
    [tableData]="resultsGrid" 
    [columnDefinitions]="cols"
    [selectedOperation]="selectedRadiusType"
    [virtualScroll]="true"
    [autoHeight]="true"
  />

  <p-dialog [draggable]="false" [(visible)]="needToCalculate" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i> <label>Please calculate PERINIX to view results.</label>
    <br />
    <br />
  </p-dialog>
  
</app-tool-loader>